/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Outcome_TitleInputs */

const en_directory_submit_outcome_title = /** @type {(inputs: Directory_Submit_Outcome_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A managed product profile`)
};

const zh_directory_submit_outcome_title = /** @type {(inputs: Directory_Submit_Outcome_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可管理的产品资料页`)
};

/**
* | output |
* | --- |
* | "A managed product profile" |
*
* @param {Directory_Submit_Outcome_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_outcome_title = /** @type {((inputs?: Directory_Submit_Outcome_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Outcome_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_outcome_title(inputs)
	return zh_directory_submit_outcome_title(inputs)
});
export { directory_submit_outcome_title as "directory.submit.outcome_title" }